import React, { useState, useEffect } from "react";
import { Phone, MapPin, Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_36d91178-24f3-40fc-9720-d06acab0d2e6/artifacts/9kjaww63_IMG_1194.jpg";

const links = [
  { href: "#offers", label: "Offers" },
  { href: "#categories", label: "Categories" },
  { href: "#gallery", label: "Our Store" },
  { href: "#why", label: "About" },
  { href: "#location", label: "Visit" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl border-b border-[#E5E1D5] shadow-[0_4px_24px_rgba(155,139,62,0.06)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a
            href="#top"
            className="flex items-center gap-3 group"
            data-testid="navbar-logo"
          >
            <div className="w-11 h-11 rounded-full overflow-hidden bg-[#F5EFE0] ring-1 ring-[#E5E1D5] flex items-center justify-center">
              <img
                src={LOGO_URL}
                alt="R Maart"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="leading-tight">
              <div className="font-display text-xl text-[#9B8B3E] tracking-wide font-semibold">
                R Maart
              </div>
              <div className="font-latin text-[10px] uppercase tracking-[0.25em] text-[#5C5646]">
                Supermart · Partur
              </div>
            </div>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.replace("#", "")}`}
                className="font-latin text-[14px] font-medium text-[#1A1813]/80 hover:text-[#9B8B3E] transition-colors relative group"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-[#9B8B3E] transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="tel:7278919919"
              data-testid="navbar-call-btn"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#9B8B3E] text-white font-medium hover:bg-[#857635] transition-colors text-sm"
            >
              <Phone className="w-4 h-4" />
              <span className="font-latin">7278919919</span>
            </a>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="md:hidden p-2 rounded-lg text-[#1A1813]"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div
            className="md:hidden pb-6 pt-2 border-t border-[#E5E1D5] bg-white"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-4 pt-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-latin text-base text-[#1A1813]/80 hover:text-[#9B8B3E]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="tel:7278919919"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#9B8B3E] text-white font-medium text-sm w-fit"
              >
                <Phone className="w-4 h-4" />
                <span className="font-latin">7278919919</span>
              </a>
              <div className="flex items-start gap-2 text-sm text-[#5C5646] pt-2 font-latin">
                <MapPin className="w-4 h-4 mt-0.5 text-[#9B8B3E]" />
                <span>Watur Road, Partur 431501</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
